# frozen_string_literal: true

require 'erb'
require 'native'
require 'vendor/snabbdom'
require 'snabberb/component'

module Snabberb
end
